import AddressVerificationService from './AddressVerificationService';
import Helpers from './AddressVerificationHelpers';
import getSuggestedAddressesSelection, {
  SuggestedAddressesSelectionResponse,
} from './getSuggestedAddressesSelection';
import AddressForm from '../forms/address/AddressForm';
import { Address } from '../forms/address/types';

class AddressVerificationProvider {
  private addressForm: AddressForm;

  private comparingAddress: Address | null;

  private isAddressVerificationEnabled: boolean;

  constructor(
    addressForm: AddressForm,
    comparingAddress: Address | null = null,
    isAddressVerificationEnabled = false,
  ) {
    this.addressForm = addressForm;
    this.comparingAddress = comparingAddress;
    this.isAddressVerificationEnabled = isAddressVerificationEnabled;
  }

  testCanVerifyAddress(): boolean {
    if (!this.isAddressVerificationEnabled) {
      return false;
    }

    if (!this.comparingAddress) {
      return true;
    }

    const address = this.addressForm.getAddress();

    if (Helpers.testAddressEquality(address, this.comparingAddress)) {
      return false;
    }

    return true;
  }

  async verifyAddress(): Promise<SuggestedAddressesSelectionResponse | null> {
    const userEnteredAddress = this.addressForm.getAddress();

    const suggestedAddresses = await AddressVerificationService.getSuggestedAddresses(
      userEnteredAddress,
    );

    if (suggestedAddresses.length === 0) {
      return null;
    }

    return getSuggestedAddressesSelection(
      suggestedAddresses,
      userEnteredAddress,
    );
  }
}

export default AddressVerificationProvider;
